import { Eye, HelpCircle, Trash } from "lucide-react";
import { useLoanApplication } from "../../context/LoanApplicationContext";
import {
  deleteLoanApplicationDocument,
  getLoanApplicationDocuments,
} from "../../sdk/applications/applications";
import LoanApplicationModal from "../../shared/LoanApplicationModal";
import { useQuery, useMutation } from "react-query";
import { useError } from "../../context/ErrorProvider";

const LoanDocuments = ({
  closeLoanDocuments,
  activeIndex,
  handleNextStep,
  loading,
  handleOpenAddDocument,
}) => {
  const { loanApplication } = useLoanApplication();
  const { showError } = useError();
  const { data: documents, refetch } = useQuery({
    queryKey: ["loan documents", loanApplication?.id],
    queryFn: () => getLoanApplicationDocuments(loanApplication?.id),
    initialData: [],
    enabled: !!loanApplication?.id,
  });

  const { mutate: deleteDocument } = useMutation({
    mutationKey: ["delete document"],
    mutationFn: (id) => deleteLoanApplicationDocument(loanApplication?.id, id),
    onSuccess: () => {
      refetch();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const handleDeleteDocument = (document) => {
    deleteDocument(document?.id);
  };
  return (
    <LoanApplicationModal
      closeBioInformation={closeLoanDocuments}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Loan documents information
      </p>
      <div className="flex items-center justify-between">
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Upload relevant documents associated with the loan application
        </p>
        <button
          onClick={handleOpenAddDocument}
          className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
        >
          Add Document
        </button>
      </div>
      <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
        <div className="w-[10%]">ID</div>
        <div className="w-[30%] text-[14px] text-[#222222] font-normal">
          NAME
        </div>
        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
          UPDATED
        </div>
        <div className="w-[20%] text-[14px] text-[#222222] font-normal">
          STATUS
        </div>
        <div className="w-[20%] truncate text-[14px] text-[#222222] font-normal">
          VIEW/ DOWNLOAD/ EDIT
        </div>
      </div>
      {documents.length > 0 ? (
        documents.map((doc) => (
          <div className="h-[40px] bg-[#F3F3F3] my-[10px] pl-[10px] flex items-center">
            <div className="w-[10%] truncate">{doc?.id}</div>
            <div className="w-[30%] truncate text-[14px] text-[#222222] font-normal">
              {doc?.documentName}
            </div>
            <div className="w-[20%] text-[14px] truncate text-[#222222] font-normal">
              {doc?.uploadedAt}
            </div>
            <div className="w-[20%] text-[14px] text-[#222222] font-normal">
              Uploaded
            </div>
            <div className="w-[20%] flex gap-3 items-center truncate text-[14px] text-[#222222] font-normal">
              <Eye className="w-4 h-4 text-[#222222] cursor-pointer" />
              <Trash
                onClick={() => handleDeleteDocument(doc)}
                fill="#222222"
                className="w-4 h-4 text-[#222222] cursor-pointer"
              />
            </div>
          </div>
        ))
      ) : (
        <div className="h-[350px] flex flex-col items-center justify-center gap-[10px]">
          <HelpCircle />
          <p>No loan document information available</p>
        </div>
      )}
    </LoanApplicationModal>
  );
};

export default LoanDocuments;
